import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { apiGet, apiPost } from 'app/shared-components/util/restAPI';
import { startLoading, stopLoading } from 'app/store/utilSlice';

export const fetchFeatures = createAsyncThunk(
  'features/fetchFeatures',
  async ({userId, scope, entityId}, { dispatch }) => {
    try {
      dispatch(startLoading());
      const apiName = 'CoreAPI2';
      let path = `/x2/subscriptionstatus/${userId}/features`;
      const params = new URLSearchParams();
      if (scope) params.append('scope', scope);
      if (entityId) params.append('entityId', entityId);
      if (params.toString()) path += `?${params.toString()}`;
      
      const options = { headers: {}, response: false };
      return await apiGet(apiName, path, options);
    } finally {
      dispatch(stopLoading());
    }
  }
);

export const enableOverage = createAsyncThunk(
  'features/enableOverage',
  async ({meterId, enabled, monthlyBudgetCents}, { dispatch }) => {
    try {
      dispatch(startLoading());
      const apiName = 'CoreAPI2';
      const path = '/x2/stripe/overage';
      const options = {
        body: { meterId, enabled, monthlyBudgetCents },
        headers: {},
        response: false
      };
      const result = await apiPost(apiName, path, options);
      return { meterId, enabled, monthlyBudgetCents, ...result };
    } finally {
      dispatch(stopLoading());
    }
  }
);

const featureSlice = createSlice({
  name: 'features',
  initialState: {
    features: [],
    currentScope: 'USER',
    currentEntityId: null,
    loading: false,
    configureOverageDialogOpen: false,
    selectedMeterId: null,
    error: null
  },
  reducers: {
    setCurrentScope: (state, action) => {
      state.currentScope = action.payload.scope;
      state.currentEntityId = action.payload.entityId || null;
    },
    openConfigureOverageDialog: (state, action) => {
      state.configureOverageDialogOpen = true;
      state.selectedMeterId = action.payload;
    },
    closeConfigureOverageDialog: (state) => {
      state.configureOverageDialogOpen = false;
      state.selectedMeterId = null;
    }
  },
  extraReducers: builder => {
    builder
      .addCase(fetchFeatures.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchFeatures.fulfilled, (state, action) => {
        state.features = action.payload;
        state.loading = false;
      })
      .addCase(fetchFeatures.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(enableOverage.fulfilled, (state, action) => {
        const index = state.features.findIndex(
          f => f.usageMeterId === action.payload.meterId
        );
        if (index >= 0) {
          state.features[index].overageEnabled = action.payload.enabled;
          state.features[index].monthlyBudgetCents = action.payload.monthlyBudgetCents;
        }
      });
  }
});

export const selectFeatures = ({ features }) => features.features;
export const selectFeaturesLoading = ({ features }) => features.loading;
export const selectCurrentScope = ({ features }) => features.currentScope;
export const selectCurrentEntityId = ({ features }) => features.currentEntityId;
export const selectConfigureOverageDialogOpen = ({ features }) => features.configureOverageDialogOpen;
export const selectSelectedMeterId = ({ features }) => features.selectedMeterId;
export const selectSelectedFeature = ({ features }) => {
  if (!features.selectedMeterId) return null;
  return features.features.find(f => f.usageMeterId === features.selectedMeterId);
};

export const { setCurrentScope, openConfigureOverageDialog, closeConfigureOverageDialog } = featureSlice.actions;
export default featureSlice.reducer;